import { useQuery } from "@tanstack/react-query";
import { WiMuleSQL } from "../../services/WiMuleSQL";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../contexts/UserContext";

export const useGetExtended = (id) => {
  const { userDetails } = useContext(UserContext);
  const fetchExtendedData = async ({ queryKey }) => {
    // Extract the query key, [_, id] where _ is a placeholder for "getExtendedData" string
    const [_key, id] = queryKey;
    // Early exit if no token is available
    if (!userDetails.userWiMuleToken) {
      throw new Error("Authentication token is missing.");
    }
    const response = await fetch(
      `${WiMuleSQL}/api/Employee/GetExtendedData?id=${id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${userDetails.userWiMuleToken}`,
        },
      }
    );

    if (!response.ok) {
      // Throws an error that will be caught by the error handling in useQuery
      throw new Error(`HTTP Error: ${response.status}`);
    }

    return response.json();
  };

  // Capture the result of useQuery
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["getExtendedData", id],
    queryFn: fetchExtendedData,
    enabled: !!id,
    // Optionally, include other configurations such as retry, staleTime, onError, onSuccess
  });

  // Return everything you need from useQuery, including the refetch function
  return { data, isLoading, isError, error };
};
